module.exports = __webpack_public_path__ + "media/פרפר.c9a1f2e7.mp3";